import * as React from 'react';

const Separator = () => <span>&nbsp;&bull;&nbsp;</span>

export default Separator;